// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   CARD
========================================= */

.DeviceTransmissionTable_card__UCZLN {
    border-radius: 12px;
    z-index: 1;
    padding: 10px 12px;
    background-color: #ffffff;
}

/* =========================================
   CARD HEADER
========================================= */

.DeviceTransmissionTable_cardHeader__dMzwf {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 8px;
    flex-wrap: wrap;
}

.DeviceTransmissionTable_titleBar__5C4w6 {
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: var(--primary-blue-theme-color);
    display: inline-block;
    align-self: center;
}

.DeviceTransmissionTable_title__dCn7u {
    font-size: 14px;
    font-weight: 700;
    color: #26384a;
    white-space: nowrap;
}

.DeviceTransmissionTable_subtitle__j8VRO {
    font-size: 11px;
    color: gray;
    font-weight: 500;
}

/* =========================================
   TABLE WRAPPER
========================================= */

.DeviceTransmissionTable_tableWrapper__QG5Ns {
    width: 100%;
    border-radius: 8px;

    max-height: 600px;
    min-height: 120px;

    overflow-x: auto;
    overflow-y: auto;
}

/* =========================================
   MAIN TABLE
========================================= */

.DeviceTransmissionTable_mainTable__sd6Kc {
    width: 100%;
    margin-bottom: 0;

    border-collapse: separate;
    border-spacing: 0;

    table-layout: fixed;
}

/* =========================================
   COLUMN WIDTHS
========================================= */

.DeviceTransmissionTable_colCity__MQACt {
    width: 15%;
}

.DeviceTransmissionTable_colStatus__-2m4w {
    width: 3%;
}

.DeviceTransmissionTable_colDelayPct__0IBJd {
    width: 6%;
}

.DeviceTransmissionTable_colNarrow__VYwWX {
    width: 6%;
}

.DeviceTransmissionTable_colBucket__djPnk {
    width: 4%;
}

/* =========================================
   TABLE HEADER
========================================= */

.DeviceTransmissionTable_mainTable__sd6Kc thead th {
    background-color: var(--primary-blue-theme-color);
    color: #ffffff;

    font-size: 11px;
    font-weight: 700;

    text-align: center;
    vertical-align: middle;

    white-space: normal;
    overflow-wrap: normal;
    word-break: normal;

    line-height: 1.2;

    padding: 4px 4px;

    position: sticky;
    top: 0;

    z-index: 3;

    border-bottom: 1px solid #e3e8ee;
}

/* =========================================
   HOURLY HEADER
========================================= */

.DeviceTransmissionTable_hourHeader__dEjMF {
    padding: 0 !important;
}

.DeviceTransmissionTable_hourHeaderContent__dmKbn {
    display: flex;

    align-items: center;
    justify-content: center;

    width: 100%;
    min-height: 30px;

    gap: 1px;
    padding: 0 2px;
}

.DeviceTransmissionTable_hourLabel__R9RB5 {
    display: inline-flex;

    align-items: center;
    justify-content: center;

    min-width: 16px;
    white-space: nowrap;
}

/* =========================================
   HOUR NAVIGATION BUTTONS
========================================= */

.DeviceTransmissionTable_hourNavButton__xN3sE {
    width: 12px;
    height: 24px;
    flex-shrink: 0;

    display: inline-flex;

    align-items: center;
    justify-content: center;

    padding: 0;
    margin: 0;

    border: 0;
    background: transparent;

    color: #ffffff;

    font-size: 14px;
    font-weight: 700;

    line-height: 1;

    cursor: pointer;

    transition:
        opacity 0.15s ease,
        transform 0.15s ease;
}

.DeviceTransmissionTable_hourNavButton__xN3sE:hover:not(:disabled) {
    opacity: 0.75;
    transform: scale(1.1);
}

.DeviceTransmissionTable_hourNavButton__xN3sE:active:not(:disabled) {
    transform: scale(0.95);
}

.DeviceTransmissionTable_hourNavButton__xN3sE:disabled {
    opacity: 0.25;
    cursor: not-allowed;
}

/* =========================================
   ONLY HOURLY COLUMNS ANIMATE
========================================= */

.DeviceTransmissionTable_hourHeaderAnimation__29beu {
    animation: DeviceTransmissionTable_hourlyColumnFade__YFF-Y 0.28s ease-out;
}

.DeviceTransmissionTable_hourCellAnimation__9gsBt {
    animation: DeviceTransmissionTable_hourlyColumnFade__YFF-Y 0.28s ease-out;
}

.DeviceTransmissionTable_hourColumnAnimation__CIt\\+U {
    animation: DeviceTransmissionTable_hourlyColumnFade__YFF-Y 0.28s ease-out;
}

@keyframes DeviceTransmissionTable_hourlyColumnFade__YFF-Y {
    from {
        opacity: 0.35;
    }

    to {
        opacity: 1;
    }
}

/* =========================================
   BODY / ROWS
========================================= */

.DeviceTransmissionTable_mainTable__sd6Kc tbody td {
    font-size: 12px;

    text-align: center;
    vertical-align: middle;

    padding: 4px 6px;

    white-space: nowrap;

    overflow: hidden;
    text-overflow: ellipsis;
}

.DeviceTransmissionTable_dataRow__Sh4QL {
    transition: background-color 0.2s ease;
}

/* =========================================
   CITY ROW
========================================= */

.DeviceTransmissionTable_cityRow__Fr2Np td {
    background-color: #ffffff;
}

.DeviceTransmissionTable_cityRow__Fr2Np:hover td {
    background-color: #f8fbff;
}

.DeviceTransmissionTable_cityRowActive__2--NU td {
    background-color: #edf5fc !important;
}

/* =========================================
   CITY CELL
========================================= */

.DeviceTransmissionTable_cityCell__f2Ais {
    text-align: left !important;

    white-space: nowrap;

    overflow: hidden;

    max-width: 0;
}

.DeviceTransmissionTable_cityCell__f2Ais:hover {
    background-color: transparent !important;
}

.DeviceTransmissionTable_cityContent__HzT\\+9 {
    display: flex;

    align-items: center;

    gap: 6px;

    min-width: 0;
}

.DeviceTransmissionTable_accordionIcon__5HgDB {
    display: inline-flex;

    align-items: center;
    justify-content: center;

    width: 12px;

    flex-shrink: 0;

    color: var(--primary-blue-theme-color);
}

.DeviceTransmissionTable_cityName__ozt9V {
    color: #26384a;

    font-size: 12px;

    font-weight: 700;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;
}

/* =========================================
   DEPOT
========================================= */

.DeviceTransmissionTable_depotRow__xWyC8 {
    background-color: #fafbfc;

    animation: DeviceTransmissionTable_depotSlideIn__qDdGX 0.15s ease-out;
}

.DeviceTransmissionTable_depotRow__xWyC8 td {
    background-color: #fafbfc !important;

    color: #6c757d;

    padding-top: 3px !important;
    padding-bottom: 3px !important;

    border-top: 0 !important;
}

.DeviceTransmissionTable_depotRow__xWyC8:hover td {
    background-color: #f4f6f8 !important;
}

.DeviceTransmissionTable_depotCell__WC9qx {
    position: relative;

    text-align: left !important;

    white-space: nowrap;

    overflow: hidden;

    max-width: 0;
}

.DeviceTransmissionTable_depotName__XocdW {
    font-size: 11px !important;

    font-weight: 500 !important;

    color: #697681 !important;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;
}

.DeviceTransmissionTable_depotIndicator__8bC4b {
    width: 6px;
    height: 6px;

    border-radius: 50%;

    background-color: #aeb8c1;

    display: inline-block;

    margin-left: 18px;
}

/* =========================================
   DEPOT ANIMATION
========================================= */

@keyframes DeviceTransmissionTable_depotSlideIn__qDdGX {
    from {
        opacity: 0;
        transform: translateY(-3px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* =========================================
   STATUS BADGE
========================================= */

.DeviceTransmissionTable_statusBadge__0nxoB {
    display: inline-block;

    font-size: 10px;

    font-weight: 600;

    padding: 3px 3px;

    border-radius: 10px;

    white-space: nowrap;
}

.DeviceTransmissionTable_statusHealthy__sGh18 {
    /* background-color: #eafaf0; */
    background-color: #1aa054;

    /* color: #1aa054; */

    border: 1px solid #b9ecd1;
}

.DeviceTransmissionTable_statusUnhealthy__W-MaU {
    /* background-color: #fdeef1; */
     background-color: #e5384d;

    /* color: #e5384d; */

    border: 1px solid #f6c6cf;
}

/* =========================================
   DELAY PACKET %
========================================= */

.DeviceTransmissionTable_delayPct__HbhgM {
    font-weight: 700;
}

/* =========================================
   BUCKET CELLS
========================================= */

.DeviceTransmissionTable_bucketCell__IoP4c {
    font-weight: 600;
}

/* download icon at the right of the card title row */
.DeviceTransmissionTable_downloadBtn__jPyJe {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;

    margin-right: 8px;
    padding: 2px;
    border: 0;
    background: transparent;

    color: #6b7280;
    cursor: pointer;
}

.DeviceTransmissionTable_downloadBtn__jPyJe:hover {
    color: #022352;
}

/* =========================================
   COLOR TONES
========================================= */

.DeviceTransmissionTable_tone_green__p3hgS {
    color: #1aa054;
}

.DeviceTransmissionTable_tone_orange__rK7Om {
    color: #e08a1e;
}

.DeviceTransmissionTable_tone_yellow__w83TS {
    color: #e6b800;
}

.DeviceTransmissionTable_tone_red__Ol9Iu {
    color: #e5384d;
}

.DeviceTransmissionTable_tone_grey__5OXGC {
    color: #aeb8c1;

    font-weight: 400;
}

/* =========================================
   LOADING
========================================= */

.DeviceTransmissionTable_loadingState__F1gej {
    display: flex;

    align-items: center;
    justify-content: center;

    gap: 6px;

    padding: 18px;

    color: #6c757d;

    font-size: 12px;
}

.DeviceTransmissionTable_spinner__93Oag {
    width: 14px;
    height: 14px;

    border-radius: 50%;

    border: 2px solid #dee2e6;

    border-top-color: var(--primary-blue-theme-color);

    animation: DeviceTransmissionTable_spin__sqUuy 0.7s linear infinite;
}

@keyframes DeviceTransmissionTable_spin__sqUuy {
    to {
        transform: rotate(360deg);
    }
}

/* =========================================
   MOBILE
========================================= */

@media (max-width: 768px) {
    .DeviceTransmissionTable_tableWrapper__QG5Ns {
        min-height: 200px;
        max-height: 280px;
    }

    .DeviceTransmissionTable_mainTable__sd6Kc thead th {
        font-size: 9px;
        padding: 3px 3px;
    }

    .DeviceTransmissionTable_mainTable__sd6Kc tbody td {
        font-size: 10px;
        padding: 3px 4px;
    }

    .DeviceTransmissionTable_hourNavButton__xN3sE {
        width: 11px;
        font-size: 12px;
    }

    .DeviceTransmissionTable_hourHeaderContent__dmKbn {
        gap: 0;
    }
}


/* =====================================================================
 * NEW FUNCTIONALITY ONLY
 * MINUTE POPOVER
 *
 * Everything above this section belongs to the original table.
 * ===================================================================== */


/* =========================================
   CLICKABLE DEPOT HOUR CELL
========================================= */

.DeviceTransmissionTable_minuteClickable__Tjxpv {
    cursor: pointer;

    transition:
        background-color 0.15s ease,
        box-shadow 0.15s ease;
}

.DeviceTransmissionTable_minuteClickable__Tjxpv:hover {
    background-color: #edf5fc !important;

    box-shadow:
        inset 0 0 0 1px
        var(--primary-blue-theme-color);
}


/* =========================================
   MINUTE POPOVER
========================================= */

.DeviceTransmissionTable_minutePopover__2gSSp {
    position: fixed;

    left: 50%;
    top: 50%;

    transform: translate(
        -50%,
        -50%
    );

    width: min(
        96vw,
        1100px
    );

    max-width: 1100px;

    background-color: #ffffff;

    border: 1px solid #dce3ea;

    border-radius: 10px;

    box-shadow:
        0 8px 30px
        rgba(0, 0, 0, 0.18);

    z-index: 1050;

    overflow: hidden;

    animation:
        DeviceTransmissionTable_minutePopoverIn__jgwTf
        0.15s ease-out;
}

@keyframes DeviceTransmissionTable_minutePopoverIn__jgwTf {
    from {
        opacity: 0;

        transform:
            translate(
                -50%,
                -48%
            );
    }

    to {
        opacity: 1;

        transform:
            translate(
                -50%,
                -50%
            );
    }
}


/* =========================================
   POPOVER HEADER
========================================= */

.DeviceTransmissionTable_minutePopoverHeader__ghyGC {
    display: flex;

    align-items: center;

    justify-content: space-between;

    min-height: 60px;

    padding: 6px 10px;

    background-color: #ffffff;

    border-bottom: 1px solid #e3e8ee;
}

.DeviceTransmissionTable_minutePopoverTitle__Mc\\+KP {
    display: flex;

    align-items: center;

    gap: 7px;

    color: #26384a;

    font-size: 12px;

    font-weight: 700;
}

.DeviceTransmissionTable_minutePopoverTitleBar__iC3PJ {
    width: 4px;

    height: 16px;

    border-radius: 2px;

    background-color:
        var(--primary-blue-theme-color);

    display: inline-block;
}

.DeviceTransmissionTable_minutePopoverHour__Cc5iJ {
    color: #6c757d;

    font-size: 11px;

    font-weight: 500;
}

.DeviceTransmissionTable_minutePopoverClose__YPQZx {
    width: 24px;

    height: 24px;

    border: 0;

    border-radius: 4px;

    background: transparent;

    color: #6c757d;

    font-size: 20px;

    line-height: 20px;

    display: flex;

    align-items: center;

    justify-content: center;

    cursor: pointer;
}

.DeviceTransmissionTable_minutePopoverClose__YPQZx:hover {
    background-color: #f1f3f5;

    color: #26384a;
}


/* =========================================
   MINUTE TABLE WRAPPER
========================================= */

.DeviceTransmissionTable_minutePopoverTableWrapper__m8bUU {
    width: 100%;

    overflow-x: auto;

    overflow-y: hidden;

    padding: 8px;
}


/* =========================================
   MINUTE TABLE
========================================= */

.DeviceTransmissionTable_minuteTable__1TBEq {
    width: 100%;

    margin-bottom: 0;

    border-collapse: separate;

    border-spacing: 0;

    table-layout: fixed;
}


/*
 * The minute table uses the same
 * visual table treatment as the
 * original table.
 */

.DeviceTransmissionTable_minuteTable__1TBEq thead th {
    background-color:
        var(--primary-blue-theme-color);

    color: #ffffff;

    font-size: 11px;

    font-weight: 700;

    text-align: center;

    vertical-align: middle;

    white-space: normal;

    line-height: 1.2;

    padding: 4px;

    border-bottom: 1px solid #e3e8ee;
}

.DeviceTransmissionTable_minuteTable__1TBEq tbody td {
    font-size: 12px;

    text-align: center;

    vertical-align: middle;

    padding: 4px 6px;

    white-space: nowrap;

    overflow: hidden;

    text-overflow: ellipsis;
}


/* =========================================
   MINUTE HEADER
========================================= */

.DeviceTransmissionTable_minuteHeader__rn6tB {
    padding: 0 !important;
}

.DeviceTransmissionTable_minuteHeaderContent__LIAwU {
    display: flex;

    align-items: center;

    justify-content: center;

    width: 100%;

    min-height: 30px;

    gap: 2px;
}


/* =========================================
   MINUTE RESPONSIVE
========================================= */

@media (max-width: 768px) {
    .DeviceTransmissionTable_minutePopover__2gSSp {
        width: 98vw;
    }

    .DeviceTransmissionTable_minutePopoverTableWrapper__m8bUU {
        padding: 5px;
    }

    .DeviceTransmissionTable_minuteTable__1TBEq thead th {
        font-size: 9px;

        padding: 3px;
    }

    .DeviceTransmissionTable_minuteTable__1TBEq tbody td {
        font-size: 10px;

        padding: 3px 4px;
    }

    .DeviceTransmissionTable_minutePopoverTitle__Mc\\+KP {
        font-size: 11px;
    }
}

/* ---------- Pagination (matches minute table theme) ---------- */
.DeviceTransmissionTable_paginationBar__Yduoz {
    --pg-primary: #7f9fd0;          /* same blue as table header */
    --pg-primary-dark: #6a8bc0;
    --pg-border: #c5d3ea;
    --pg-hover-bg: #eaf0fa;
    --pg-text: #3f5b8a;

    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
    padding: 10px 12px;
    border-top: 1px solid #e3e9f3;
    background: #f8fafd;
    font-size: 14px;
}

.DeviceTransmissionTable_paginationInfo__5lfKF {
    color: #4a5568;
}

.DeviceTransmissionTable_paginationControls__jkkCK {
    display: flex;
    align-items: center;
    gap: 6px;
}

.DeviceTransmissionTable_pageSizeLabel__5Qk-4 {
    display: flex;
    align-items: center;
    margin: 0 12px 0 0;
    color: #4a5568;
}

.DeviceTransmissionTable_pageSizeSelect__UhwR4 {
    height: 34px;
    padding: 0 8px;
    border: 1px solid var(--pg-border);
    border-radius: 4px;
    background: #fff;
    color: var(--pg-text);
    cursor: pointer;
}

.DeviceTransmissionTable_pageSizeSelect__UhwR4:focus {
    outline: none;
    border-color: var(--pg-primary);
    box-shadow: 0 0 0 2px rgba(127, 159, 208, 0.35);
}

.DeviceTransmissionTable_pageBtn__797Xa {
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    border: 1px solid var(--pg-border);
    border-radius: 4px;
    background: #fff;
    color: var(--pg-text);
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.DeviceTransmissionTable_pageBtn__797Xa:hover:not(:disabled) {
    background: var(--pg-hover-bg);
    border-color: var(--pg-primary);
}

.DeviceTransmissionTable_pageBtn__797Xa:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px rgba(127, 159, 208, 0.35);
}

.DeviceTransmissionTable_pageBtn__797Xa:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.DeviceTransmissionTable_pageBtnActive__K8v6v,
.DeviceTransmissionTable_pageBtnActive__K8v6v:hover:not(:disabled) {
    background: var(--pg-primary);
    border-color: var(--pg-primary);
    color: #fff;
    font-weight: 600;
}

.DeviceTransmissionTable_pageBtnActive__K8v6v:hover:not(:disabled) {
    background: var(--pg-primary-dark);
}

.DeviceTransmissionTable_pageEllipsis__8TJ-W {
    padding: 0 4px;
    color: var(--pg-text);
}

/* =====================================================================
 * VIN-WISE TABLE
 * ===================================================================== */

.DeviceTransmissionTable_colDepot__mhoLW {
    width: 9%;
}

.DeviceTransmissionTable_colVin__FxiNb {
    width: 13%;
}

.DeviceTransmissionTable_vinRow__Rh38I td {
    background-color: #ffffff;
}

.DeviceTransmissionTable_vinRow__Rh38I:hover td {
    background-color: #f8fbff;
}

.DeviceTransmissionTable_depotText__JSKvw {
    color: #697681;
    font-size: 11px;
    font-weight: 600;
}

.DeviceTransmissionTable_vinCell__spFwi {
    text-align: left !important;
    color: #26384a;
    font-weight: 700;
    letter-spacing: 0.02em;
}


/* open VIN row is the "tab strip": a shade darker than the minute row under it */
.DeviceTransmissionTable_vinRowActive__x9a9m td {
    background-color: #dce8f6 !important;
}

/* selected hour = browser-style tab: rounded top, same colour as the minute row
   below so the two read as one piece. The tab is drawn with pseudo elements
   because border-radius does not apply to collapsed table cells.
   \`td.\` keeps it above \`.vinRowActive td\` and the bootstrap cell shadow;
   :hover is listed too so the hover style can't wash the selection out */
td.DeviceTransmissionTable_hourCellSelected__HJFk9,
td.DeviceTransmissionTable_hourCellSelected__HJFk9:hover {
    position: relative;
    z-index: 0;

    background-color: #dce8f6 !important;
    box-shadow: none !important;
    /* hide the line between the tab and the minute row */
    border-bottom-color: #f4f8fc !important;

    font-weight: 800;
}

/* tab body */
td.DeviceTransmissionTable_hourCellSelected__HJFk9::before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 3px;
    right: 2px;
    bottom: -1px;
    left: 2px;

    background: #f4f8fc;
    border-top: 2px solid var(--primary-blue-theme-color);
    border-radius: 8px 8px 0 0;
}

/* outward curves where the tab meets the minute row */
td.DeviceTransmissionTable_hourCellSelected__HJFk9::after {
    content: "";
    position: absolute;
    z-index: -1;
    right: -6px;
    bottom: -1px;
    left: -6px;
    height: 8px;

    background:
        radial-gradient(circle at 0 0, transparent 8px, #f4f8fc 8.5px) left / 8px 8px no-repeat,
        radial-gradient(circle at 100% 0, transparent 8px, #f4f8fc 8.5px) right / 8px 8px no-repeat;
}


/* =====================================================================
 * MINUTE-WISE ROW (same columns as the VIN row, opens under it)
 * ===================================================================== */

.DeviceTransmissionTable_minuteRow__USvzk td {
    background-color: #f4f8fc !important;
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    border-top: 0 !important;
    animation: DeviceTransmissionTable_depotSlideIn__qDdGX 0.15s ease-out;
}

.DeviceTransmissionTable_minuteRow__USvzk:hover td {
    background-color: #edf3fa !important;
}

.DeviceTransmissionTable_minuteRowLabelCell__LaiGe {
    text-align: left !important;
    border-left: 3px solid var(--primary-blue-theme-color) !important;
}

.DeviceTransmissionTable_minuteRowLabel__ZEbrO {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: #4b71a2;
    font-size: 11px;
    font-weight: 700;
}

.DeviceTransmissionTable_minuteRowRange__bleMS {
    text-align: left !important;
    color: #697681;
    font-size: 11px !important;
    font-weight: 600;
}

.DeviceTransmissionTable_minuteCloseBtn__EeFUp {
    width: 16px;
    height: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 1px solid #c5d3ea;
    border-radius: 4px;
    background-color: #ffffff;
    color: #6b7280;
    cursor: pointer;
}

.DeviceTransmissionTable_minuteCloseBtn__EeFUp:hover {
    background-color: #fdeef1;
    border-color: #f6c6cf;
    color: #c42a3d;
}

.DeviceTransmissionTable_minuteValueCell__uUmDY {
    padding: 1px 2px !important;
}

.DeviceTransmissionTable_minuteCellContent__mFhZH {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1px;
}

.DeviceTransmissionTable_minuteCellStack__rqW9c {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    min-width: 0;
    line-height: 1.05;
}

.DeviceTransmissionTable_minuteCellTime__uq4O7 {
    color: #8a96a3;
    font-size: 9px;
    font-weight: 600;
}

.DeviceTransmissionTable_minuteCellValue__xYCc2 {
    font-size: 11px;
    font-weight: 700;
}

.DeviceTransmissionTable_minuteNavBtn__zU3W6 {
    width: 11px;
    height: 20px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
    color: #4b71a2;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
}

.DeviceTransmissionTable_minuteNavBtn__zU3W6:hover:not(:disabled) {
    color: #022352;
}

.DeviceTransmissionTable_minuteNavBtn__zU3W6:disabled {
    opacity: 0.25;
    cursor: not-allowed;
}

/* =========================================
   DEVICE ID COLUMN
========================================= */

.DeviceTransmissionTable_colDeviceId__iitgU {
    width: 9%;
}

.DeviceTransmissionTable_deviceIdCell__Y-n8S {
    color: #697681;
    font-size: 11px !important;
    font-weight: 600;
    letter-spacing: 0.02em;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/DeviceHealth/DeviceTransmissionTable.module.css"],"names":[],"mappings":"AAAA;;2CAE2C;;AAE3C;IACI,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,iDAAiD;IACjD,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,WAAW;IACX,kBAAkB;;IAElB,iBAAiB;IACjB,iBAAiB;;IAEjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,WAAW;IACX,gBAAgB;;IAEhB,yBAAyB;IACzB,iBAAiB;;IAEjB,mBAAmB;AACvB;;AAEA;;2CAE2C;;AAE3C;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;;2CAE2C;;AAE3C;IACI,iDAAiD;IACjD,cAAc;;IAEd,eAAe;IACf,gBAAgB;;IAEhB,kBAAkB;IAClB,sBAAsB;;IAEtB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;;IAElB,gBAAgB;;IAEhB,gBAAgB;;IAEhB,gBAAgB;IAChB,MAAM;;IAEN,UAAU;;IAEV,gCAAgC;AACpC;;AAEA;;2CAE2C;;AAE3C;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;;IAEb,mBAAmB;IACnB,uBAAuB;;IAEvB,WAAW;IACX,gBAAgB;;IAEhB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,oBAAoB;;IAEpB,mBAAmB;IACnB,uBAAuB;;IAEvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;;2CAE2C;;AAE3C;IACI,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,oBAAoB;;IAEpB,mBAAmB;IACnB,uBAAuB;;IAEvB,UAAU;IACV,SAAS;;IAET,SAAS;IACT,uBAAuB;;IAEvB,cAAc;;IAEd,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,eAAe;;IAEf;;4BAEwB;AAC5B;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;2CAE2C;;AAE3C;IACI,yEAA0C;AAC9C;;AAEA;IACI,yEAA0C;AAC9C;;AAEA;IACI,yEAA0C;AAC9C;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;;2CAE2C;;AAE3C;IACI,eAAe;;IAEf,kBAAkB;IAClB,sBAAsB;;IAEtB,gBAAgB;;IAEhB,mBAAmB;;IAEnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;2CAE2C;;AAE3C;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;2CAE2C;;AAE3C;IACI,2BAA2B;;IAE3B,mBAAmB;;IAEnB,gBAAgB;;IAEhB,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;;IAEb,mBAAmB;;IAEnB,QAAQ;;IAER,YAAY;AAChB;;AAEA;IACI,oBAAoB;;IAEpB,mBAAmB;IACnB,uBAAuB;;IAEvB,WAAW;;IAEX,cAAc;;IAEd,sCAAsC;AAC1C;;AAEA;IACI,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;;IAEhB,gBAAgB;;IAEhB,uBAAuB;;IAEvB,mBAAmB;AACvB;;AAEA;;2CAE2C;;AAE3C;IACI,yBAAyB;;IAEzB,qEAAsC;AAC1C;;AAEA;IACI,oCAAoC;;IAEpC,cAAc;;IAEd,2BAA2B;IAC3B,8BAA8B;;IAE9B,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;;IAElB,2BAA2B;;IAE3B,mBAAmB;;IAEnB,gBAAgB;;IAEhB,YAAY;AAChB;;AAEA;IACI,0BAA0B;;IAE1B,2BAA2B;;IAE3B,yBAAyB;;IAEzB,gBAAgB;;IAEhB,uBAAuB;;IAEvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;;IAEX,kBAAkB;;IAElB,yBAAyB;;IAEzB,qBAAqB;;IAErB,iBAAiB;AACrB;;AAEA;;2CAE2C;;AAE3C;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;2CAE2C;;AAE3C;IACI,qBAAqB;;IAErB,eAAe;;IAEf,gBAAgB;;IAEhB,gBAAgB;;IAEhB,mBAAmB;;IAEnB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;;IAEzB,oBAAoB;;IAEpB,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;KAC9B,yBAAyB;;IAE1B,oBAAoB;;IAEpB,yBAAyB;AAC7B;;AAEA;;2CAE2C;;AAE3C;IACI,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,gBAAgB;AACpB;;AAEA,qDAAqD;AACrD;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;;IAEnB,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,uBAAuB;;IAEvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;;2CAE2C;;AAE3C;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;;IAEd,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;;IAEb,mBAAmB;IACnB,uBAAuB;;IAEvB,QAAQ;;IAER,aAAa;;IAEb,cAAc;;IAEd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,kBAAkB;;IAElB,yBAAyB;;IAEzB,iDAAiD;;IAEjD,mEAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;2CAE2C;;AAE3C;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,MAAM;IACV;AACJ;;;AAGA;;;;;0EAK0E;;;AAG1E;;2CAE2C;;AAE3C;IACI,eAAe;;IAEf;;6BAEyB;AAC7B;;AAEA;IACI,oCAAoC;;IAEpC;;uCAEmC;AACvC;;;AAGA;;2CAE2C;;AAE3C;IACI,eAAe;;IAEf,SAAS;IACT,QAAQ;;IAER;;;KAGC;;IAED;;;KAGC;;IAED,iBAAiB;;IAEjB,yBAAyB;;IAEzB,yBAAyB;;IAEzB,mBAAmB;;IAEnB;;2BAEuB;;IAEvB,aAAa;;IAEb,gBAAgB;;IAEhB;;sBAEkB;AACtB;;AAEA;IACI;QACI,UAAU;;QAEV;;;;aAIK;IACT;;IAEA;QACI,UAAU;;QAEV;;;;aAIK;IACT;AACJ;;;AAGA;;2CAE2C;;AAE3C;IACI,aAAa;;IAEb,mBAAmB;;IAEnB,8BAA8B;;IAE9B,gBAAgB;;IAEhB,iBAAiB;;IAEjB,yBAAyB;;IAEzB,gCAAgC;AACpC;;AAEA;IACI,aAAa;;IAEb,mBAAmB;;IAEnB,QAAQ;;IAER,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;AACpB;;AAEA;IACI,UAAU;;IAEV,YAAY;;IAEZ,kBAAkB;;IAElB;uCACmC;;IAEnC,qBAAqB;AACzB;;AAEA;IACI,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;AACpB;;AAEA;IACI,WAAW;;IAEX,YAAY;;IAEZ,SAAS;;IAET,kBAAkB;;IAElB,uBAAuB;;IAEvB,cAAc;;IAEd,eAAe;;IAEf,iBAAiB;;IAEjB,aAAa;;IAEb,mBAAmB;;IAEnB,uBAAuB;;IAEvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;;IAEzB,cAAc;AAClB;;;AAGA;;2CAE2C;;AAE3C;IACI,WAAW;;IAEX,gBAAgB;;IAEhB,kBAAkB;;IAElB,YAAY;AAChB;;;AAGA;;2CAE2C;;AAE3C;IACI,WAAW;;IAEX,gBAAgB;;IAEhB,yBAAyB;;IAEzB,iBAAiB;;IAEjB,mBAAmB;AACvB;;;AAGA;;;;EAIE;;AAEF;IACI;uCACmC;;IAEnC,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;;IAEhB,kBAAkB;;IAElB,sBAAsB;;IAEtB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,YAAY;;IAEZ,gCAAgC;AACpC;;AAEA;IACI,eAAe;;IAEf,kBAAkB;;IAElB,sBAAsB;;IAEtB,gBAAgB;;IAEhB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,uBAAuB;AAC3B;;;AAGA;;2CAE2C;;AAE3C;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;;IAEb,mBAAmB;;IAEnB,uBAAuB;;IAEvB,WAAW;;IAEX,gBAAgB;;IAEhB,QAAQ;AACZ;;;AAGA;;2CAE2C;;AAE3C;IACI;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;;QAEd,YAAY;IAChB;;IAEA;QACI,eAAe;;QAEf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,kEAAkE;AAClE;IACI,qBAAqB,WAAW,8BAA8B;IAC9D,0BAA0B;IAC1B,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;;IAElB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,6DAA6D;AACjE;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,6BAA6B;IAC7B,+BAA+B;IAC/B,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;0EAE0E;;AAE1E;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;;AAGA,iFAAiF;AACjF;IACI,oCAAoC;AACxC;;AAEA;;;;yEAIyE;AACzE;;IAEI,kBAAkB;IAClB,UAAU;;IAEV,oCAAoC;IACpC,2BAA2B;IAC3B,qDAAqD;IACrD,uCAAuC;;IAEvC,gBAAgB;AACpB;;AAEA,aAAa;AACb;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,SAAS;;IAET,mBAAmB;IACnB,qDAAqD;IACrD,0BAA0B;AAC9B;;AAEA,sDAAsD;AACtD;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;;IAEX;;mGAE+F;AACnG;;;AAGA;;0EAE0E;;AAE1E;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,8BAA8B;IAC9B,wBAAwB;IACxB,qEAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,iEAAiE;AACrE;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;2CAE2C;;AAE3C;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;IAChB,sBAAsB;AAC1B","sourcesContent":["/* =========================================\n   CARD\n========================================= */\n\n.card {\n    border-radius: 12px;\n    z-index: 1;\n    padding: 10px 12px;\n    background-color: #ffffff;\n}\n\n/* =========================================\n   CARD HEADER\n========================================= */\n\n.cardHeader {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    margin-bottom: 8px;\n    flex-wrap: wrap;\n}\n\n.titleBar {\n    width: 4px;\n    height: 16px;\n    border-radius: 2px;\n    background-color: var(--primary-blue-theme-color);\n    display: inline-block;\n    align-self: center;\n}\n\n.title {\n    font-size: 14px;\n    font-weight: 700;\n    color: #26384a;\n    white-space: nowrap;\n}\n\n.subtitle {\n    font-size: 11px;\n    color: gray;\n    font-weight: 500;\n}\n\n/* =========================================\n   TABLE WRAPPER\n========================================= */\n\n.tableWrapper {\n    width: 100%;\n    border-radius: 8px;\n\n    max-height: 600px;\n    min-height: 120px;\n\n    overflow-x: auto;\n    overflow-y: auto;\n}\n\n/* =========================================\n   MAIN TABLE\n========================================= */\n\n.mainTable {\n    width: 100%;\n    margin-bottom: 0;\n\n    border-collapse: separate;\n    border-spacing: 0;\n\n    table-layout: fixed;\n}\n\n/* =========================================\n   COLUMN WIDTHS\n========================================= */\n\n.colCity {\n    width: 15%;\n}\n\n.colStatus {\n    width: 3%;\n}\n\n.colDelayPct {\n    width: 6%;\n}\n\n.colNarrow {\n    width: 6%;\n}\n\n.colBucket {\n    width: 4%;\n}\n\n/* =========================================\n   TABLE HEADER\n========================================= */\n\n.mainTable thead th {\n    background-color: var(--primary-blue-theme-color);\n    color: #ffffff;\n\n    font-size: 11px;\n    font-weight: 700;\n\n    text-align: center;\n    vertical-align: middle;\n\n    white-space: normal;\n    overflow-wrap: normal;\n    word-break: normal;\n\n    line-height: 1.2;\n\n    padding: 4px 4px;\n\n    position: sticky;\n    top: 0;\n\n    z-index: 3;\n\n    border-bottom: 1px solid #e3e8ee;\n}\n\n/* =========================================\n   HOURLY HEADER\n========================================= */\n\n.hourHeader {\n    padding: 0 !important;\n}\n\n.hourHeaderContent {\n    display: flex;\n\n    align-items: center;\n    justify-content: center;\n\n    width: 100%;\n    min-height: 30px;\n\n    gap: 1px;\n    padding: 0 2px;\n}\n\n.hourLabel {\n    display: inline-flex;\n\n    align-items: center;\n    justify-content: center;\n\n    min-width: 16px;\n    white-space: nowrap;\n}\n\n/* =========================================\n   HOUR NAVIGATION BUTTONS\n========================================= */\n\n.hourNavButton {\n    width: 12px;\n    height: 24px;\n    flex-shrink: 0;\n\n    display: inline-flex;\n\n    align-items: center;\n    justify-content: center;\n\n    padding: 0;\n    margin: 0;\n\n    border: 0;\n    background: transparent;\n\n    color: #ffffff;\n\n    font-size: 14px;\n    font-weight: 700;\n\n    line-height: 1;\n\n    cursor: pointer;\n\n    transition:\n        opacity 0.15s ease,\n        transform 0.15s ease;\n}\n\n.hourNavButton:hover:not(:disabled) {\n    opacity: 0.75;\n    transform: scale(1.1);\n}\n\n.hourNavButton:active:not(:disabled) {\n    transform: scale(0.95);\n}\n\n.hourNavButton:disabled {\n    opacity: 0.25;\n    cursor: not-allowed;\n}\n\n/* =========================================\n   ONLY HOURLY COLUMNS ANIMATE\n========================================= */\n\n.hourHeaderAnimation {\n    animation: hourlyColumnFade 0.28s ease-out;\n}\n\n.hourCellAnimation {\n    animation: hourlyColumnFade 0.28s ease-out;\n}\n\n.hourColumnAnimation {\n    animation: hourlyColumnFade 0.28s ease-out;\n}\n\n@keyframes hourlyColumnFade {\n    from {\n        opacity: 0.35;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n/* =========================================\n   BODY / ROWS\n========================================= */\n\n.mainTable tbody td {\n    font-size: 12px;\n\n    text-align: center;\n    vertical-align: middle;\n\n    padding: 4px 6px;\n\n    white-space: nowrap;\n\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.dataRow {\n    transition: background-color 0.2s ease;\n}\n\n/* =========================================\n   CITY ROW\n========================================= */\n\n.cityRow td {\n    background-color: #ffffff;\n}\n\n.cityRow:hover td {\n    background-color: #f8fbff;\n}\n\n.cityRowActive td {\n    background-color: #edf5fc !important;\n}\n\n/* =========================================\n   CITY CELL\n========================================= */\n\n.cityCell {\n    text-align: left !important;\n\n    white-space: nowrap;\n\n    overflow: hidden;\n\n    max-width: 0;\n}\n\n.cityCell:hover {\n    background-color: transparent !important;\n}\n\n.cityContent {\n    display: flex;\n\n    align-items: center;\n\n    gap: 6px;\n\n    min-width: 0;\n}\n\n.accordionIcon {\n    display: inline-flex;\n\n    align-items: center;\n    justify-content: center;\n\n    width: 12px;\n\n    flex-shrink: 0;\n\n    color: var(--primary-blue-theme-color);\n}\n\n.cityName {\n    color: #26384a;\n\n    font-size: 12px;\n\n    font-weight: 700;\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n\n    white-space: nowrap;\n}\n\n/* =========================================\n   DEPOT\n========================================= */\n\n.depotRow {\n    background-color: #fafbfc;\n\n    animation: depotSlideIn 0.15s ease-out;\n}\n\n.depotRow td {\n    background-color: #fafbfc !important;\n\n    color: #6c757d;\n\n    padding-top: 3px !important;\n    padding-bottom: 3px !important;\n\n    border-top: 0 !important;\n}\n\n.depotRow:hover td {\n    background-color: #f4f6f8 !important;\n}\n\n.depotCell {\n    position: relative;\n\n    text-align: left !important;\n\n    white-space: nowrap;\n\n    overflow: hidden;\n\n    max-width: 0;\n}\n\n.depotName {\n    font-size: 11px !important;\n\n    font-weight: 500 !important;\n\n    color: #697681 !important;\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n\n    white-space: nowrap;\n}\n\n.depotIndicator {\n    width: 6px;\n    height: 6px;\n\n    border-radius: 50%;\n\n    background-color: #aeb8c1;\n\n    display: inline-block;\n\n    margin-left: 18px;\n}\n\n/* =========================================\n   DEPOT ANIMATION\n========================================= */\n\n@keyframes depotSlideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-3px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* =========================================\n   STATUS BADGE\n========================================= */\n\n.statusBadge {\n    display: inline-block;\n\n    font-size: 10px;\n\n    font-weight: 600;\n\n    padding: 3px 3px;\n\n    border-radius: 10px;\n\n    white-space: nowrap;\n}\n\n.statusHealthy {\n    /* background-color: #eafaf0; */\n    background-color: #1aa054;\n\n    /* color: #1aa054; */\n\n    border: 1px solid #b9ecd1;\n}\n\n.statusUnhealthy {\n    /* background-color: #fdeef1; */\n     background-color: #e5384d;\n\n    /* color: #e5384d; */\n\n    border: 1px solid #f6c6cf;\n}\n\n/* =========================================\n   DELAY PACKET %\n========================================= */\n\n.delayPct {\n    font-weight: 700;\n}\n\n/* =========================================\n   BUCKET CELLS\n========================================= */\n\n.bucketCell {\n    font-weight: 600;\n}\n\n/* download icon at the right of the card title row */\n.downloadBtn {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n\n    margin-right: 8px;\n    padding: 2px;\n    border: 0;\n    background: transparent;\n\n    color: #6b7280;\n    cursor: pointer;\n}\n\n.downloadBtn:hover {\n    color: #022352;\n}\n\n/* =========================================\n   COLOR TONES\n========================================= */\n\n.tone_green {\n    color: #1aa054;\n}\n\n.tone_orange {\n    color: #e08a1e;\n}\n\n.tone_yellow {\n    color: #e6b800;\n}\n\n.tone_red {\n    color: #e5384d;\n}\n\n.tone_grey {\n    color: #aeb8c1;\n\n    font-weight: 400;\n}\n\n/* =========================================\n   LOADING\n========================================= */\n\n.loadingState {\n    display: flex;\n\n    align-items: center;\n    justify-content: center;\n\n    gap: 6px;\n\n    padding: 18px;\n\n    color: #6c757d;\n\n    font-size: 12px;\n}\n\n.spinner {\n    width: 14px;\n    height: 14px;\n\n    border-radius: 50%;\n\n    border: 2px solid #dee2e6;\n\n    border-top-color: var(--primary-blue-theme-color);\n\n    animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* =========================================\n   MOBILE\n========================================= */\n\n@media (max-width: 768px) {\n    .tableWrapper {\n        min-height: 200px;\n        max-height: 280px;\n    }\n\n    .mainTable thead th {\n        font-size: 9px;\n        padding: 3px 3px;\n    }\n\n    .mainTable tbody td {\n        font-size: 10px;\n        padding: 3px 4px;\n    }\n\n    .hourNavButton {\n        width: 11px;\n        font-size: 12px;\n    }\n\n    .hourHeaderContent {\n        gap: 0;\n    }\n}\n\n\n/* =====================================================================\n * NEW FUNCTIONALITY ONLY\n * MINUTE POPOVER\n *\n * Everything above this section belongs to the original table.\n * ===================================================================== */\n\n\n/* =========================================\n   CLICKABLE DEPOT HOUR CELL\n========================================= */\n\n.minuteClickable {\n    cursor: pointer;\n\n    transition:\n        background-color 0.15s ease,\n        box-shadow 0.15s ease;\n}\n\n.minuteClickable:hover {\n    background-color: #edf5fc !important;\n\n    box-shadow:\n        inset 0 0 0 1px\n        var(--primary-blue-theme-color);\n}\n\n\n/* =========================================\n   MINUTE POPOVER\n========================================= */\n\n.minutePopover {\n    position: fixed;\n\n    left: 50%;\n    top: 50%;\n\n    transform: translate(\n        -50%,\n        -50%\n    );\n\n    width: min(\n        96vw,\n        1100px\n    );\n\n    max-width: 1100px;\n\n    background-color: #ffffff;\n\n    border: 1px solid #dce3ea;\n\n    border-radius: 10px;\n\n    box-shadow:\n        0 8px 30px\n        rgba(0, 0, 0, 0.18);\n\n    z-index: 1050;\n\n    overflow: hidden;\n\n    animation:\n        minutePopoverIn\n        0.15s ease-out;\n}\n\n@keyframes minutePopoverIn {\n    from {\n        opacity: 0;\n\n        transform:\n            translate(\n                -50%,\n                -48%\n            );\n    }\n\n    to {\n        opacity: 1;\n\n        transform:\n            translate(\n                -50%,\n                -50%\n            );\n    }\n}\n\n\n/* =========================================\n   POPOVER HEADER\n========================================= */\n\n.minutePopoverHeader {\n    display: flex;\n\n    align-items: center;\n\n    justify-content: space-between;\n\n    min-height: 60px;\n\n    padding: 6px 10px;\n\n    background-color: #ffffff;\n\n    border-bottom: 1px solid #e3e8ee;\n}\n\n.minutePopoverTitle {\n    display: flex;\n\n    align-items: center;\n\n    gap: 7px;\n\n    color: #26384a;\n\n    font-size: 12px;\n\n    font-weight: 700;\n}\n\n.minutePopoverTitleBar {\n    width: 4px;\n\n    height: 16px;\n\n    border-radius: 2px;\n\n    background-color:\n        var(--primary-blue-theme-color);\n\n    display: inline-block;\n}\n\n.minutePopoverHour {\n    color: #6c757d;\n\n    font-size: 11px;\n\n    font-weight: 500;\n}\n\n.minutePopoverClose {\n    width: 24px;\n\n    height: 24px;\n\n    border: 0;\n\n    border-radius: 4px;\n\n    background: transparent;\n\n    color: #6c757d;\n\n    font-size: 20px;\n\n    line-height: 20px;\n\n    display: flex;\n\n    align-items: center;\n\n    justify-content: center;\n\n    cursor: pointer;\n}\n\n.minutePopoverClose:hover {\n    background-color: #f1f3f5;\n\n    color: #26384a;\n}\n\n\n/* =========================================\n   MINUTE TABLE WRAPPER\n========================================= */\n\n.minutePopoverTableWrapper {\n    width: 100%;\n\n    overflow-x: auto;\n\n    overflow-y: hidden;\n\n    padding: 8px;\n}\n\n\n/* =========================================\n   MINUTE TABLE\n========================================= */\n\n.minuteTable {\n    width: 100%;\n\n    margin-bottom: 0;\n\n    border-collapse: separate;\n\n    border-spacing: 0;\n\n    table-layout: fixed;\n}\n\n\n/*\n * The minute table uses the same\n * visual table treatment as the\n * original table.\n */\n\n.minuteTable thead th {\n    background-color:\n        var(--primary-blue-theme-color);\n\n    color: #ffffff;\n\n    font-size: 11px;\n\n    font-weight: 700;\n\n    text-align: center;\n\n    vertical-align: middle;\n\n    white-space: normal;\n\n    line-height: 1.2;\n\n    padding: 4px;\n\n    border-bottom: 1px solid #e3e8ee;\n}\n\n.minuteTable tbody td {\n    font-size: 12px;\n\n    text-align: center;\n\n    vertical-align: middle;\n\n    padding: 4px 6px;\n\n    white-space: nowrap;\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n}\n\n\n/* =========================================\n   MINUTE HEADER\n========================================= */\n\n.minuteHeader {\n    padding: 0 !important;\n}\n\n.minuteHeaderContent {\n    display: flex;\n\n    align-items: center;\n\n    justify-content: center;\n\n    width: 100%;\n\n    min-height: 30px;\n\n    gap: 2px;\n}\n\n\n/* =========================================\n   MINUTE RESPONSIVE\n========================================= */\n\n@media (max-width: 768px) {\n    .minutePopover {\n        width: 98vw;\n    }\n\n    .minutePopoverTableWrapper {\n        padding: 5px;\n    }\n\n    .minuteTable thead th {\n        font-size: 9px;\n\n        padding: 3px;\n    }\n\n    .minuteTable tbody td {\n        font-size: 10px;\n\n        padding: 3px 4px;\n    }\n\n    .minutePopoverTitle {\n        font-size: 11px;\n    }\n}\n\n/* ---------- Pagination (matches minute table theme) ---------- */\n.paginationBar {\n    --pg-primary: #7f9fd0;          /* same blue as table header */\n    --pg-primary-dark: #6a8bc0;\n    --pg-border: #c5d3ea;\n    --pg-hover-bg: #eaf0fa;\n    --pg-text: #3f5b8a;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 10px;\n    padding: 10px 12px;\n    border-top: 1px solid #e3e9f3;\n    background: #f8fafd;\n    font-size: 14px;\n}\n\n.paginationInfo {\n    color: #4a5568;\n}\n\n.paginationControls {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.pageSizeLabel {\n    display: flex;\n    align-items: center;\n    margin: 0 12px 0 0;\n    color: #4a5568;\n}\n\n.pageSizeSelect {\n    height: 34px;\n    padding: 0 8px;\n    border: 1px solid var(--pg-border);\n    border-radius: 4px;\n    background: #fff;\n    color: var(--pg-text);\n    cursor: pointer;\n}\n\n.pageSizeSelect:focus {\n    outline: none;\n    border-color: var(--pg-primary);\n    box-shadow: 0 0 0 2px rgba(127, 159, 208, 0.35);\n}\n\n.pageBtn {\n    min-width: 20px;\n    height: 20px;\n    padding: 0 6px;\n    border: 1px solid var(--pg-border);\n    border-radius: 4px;\n    background: #fff;\n    color: var(--pg-text);\n    cursor: pointer;\n    transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.pageBtn:hover:not(:disabled) {\n    background: var(--pg-hover-bg);\n    border-color: var(--pg-primary);\n}\n\n.pageBtn:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(127, 159, 208, 0.35);\n}\n\n.pageBtn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.pageBtnActive,\n.pageBtnActive:hover:not(:disabled) {\n    background: var(--pg-primary);\n    border-color: var(--pg-primary);\n    color: #fff;\n    font-weight: 600;\n}\n\n.pageBtnActive:hover:not(:disabled) {\n    background: var(--pg-primary-dark);\n}\n\n.pageEllipsis {\n    padding: 0 4px;\n    color: var(--pg-text);\n}\n\n/* =====================================================================\n * VIN-WISE TABLE\n * ===================================================================== */\n\n.colDepot {\n    width: 9%;\n}\n\n.colVin {\n    width: 13%;\n}\n\n.vinRow td {\n    background-color: #ffffff;\n}\n\n.vinRow:hover td {\n    background-color: #f8fbff;\n}\n\n.depotText {\n    color: #697681;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.vinCell {\n    text-align: left !important;\n    color: #26384a;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n}\n\n\n/* open VIN row is the \"tab strip\": a shade darker than the minute row under it */\n.vinRowActive td {\n    background-color: #dce8f6 !important;\n}\n\n/* selected hour = browser-style tab: rounded top, same colour as the minute row\n   below so the two read as one piece. The tab is drawn with pseudo elements\n   because border-radius does not apply to collapsed table cells.\n   `td.` keeps it above `.vinRowActive td` and the bootstrap cell shadow;\n   :hover is listed too so the hover style can't wash the selection out */\ntd.hourCellSelected,\ntd.hourCellSelected:hover {\n    position: relative;\n    z-index: 0;\n\n    background-color: #dce8f6 !important;\n    box-shadow: none !important;\n    /* hide the line between the tab and the minute row */\n    border-bottom-color: #f4f8fc !important;\n\n    font-weight: 800;\n}\n\n/* tab body */\ntd.hourCellSelected::before {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    top: 3px;\n    right: 2px;\n    bottom: -1px;\n    left: 2px;\n\n    background: #f4f8fc;\n    border-top: 2px solid var(--primary-blue-theme-color);\n    border-radius: 8px 8px 0 0;\n}\n\n/* outward curves where the tab meets the minute row */\ntd.hourCellSelected::after {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    right: -6px;\n    bottom: -1px;\n    left: -6px;\n    height: 8px;\n\n    background:\n        radial-gradient(circle at 0 0, transparent 8px, #f4f8fc 8.5px) left / 8px 8px no-repeat,\n        radial-gradient(circle at 100% 0, transparent 8px, #f4f8fc 8.5px) right / 8px 8px no-repeat;\n}\n\n\n/* =====================================================================\n * MINUTE-WISE ROW (same columns as the VIN row, opens under it)\n * ===================================================================== */\n\n.minuteRow td {\n    background-color: #f4f8fc !important;\n    padding-top: 2px !important;\n    padding-bottom: 2px !important;\n    border-top: 0 !important;\n    animation: depotSlideIn 0.15s ease-out;\n}\n\n.minuteRow:hover td {\n    background-color: #edf3fa !important;\n}\n\n.minuteRowLabelCell {\n    text-align: left !important;\n    border-left: 3px solid var(--primary-blue-theme-color) !important;\n}\n\n.minuteRowLabel {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    color: #4b71a2;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.minuteRowRange {\n    text-align: left !important;\n    color: #697681;\n    font-size: 11px !important;\n    font-weight: 600;\n}\n\n.minuteCloseBtn {\n    width: 16px;\n    height: 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: 1px solid #c5d3ea;\n    border-radius: 4px;\n    background-color: #ffffff;\n    color: #6b7280;\n    cursor: pointer;\n}\n\n.minuteCloseBtn:hover {\n    background-color: #fdeef1;\n    border-color: #f6c6cf;\n    color: #c42a3d;\n}\n\n.minuteValueCell {\n    padding: 1px 2px !important;\n}\n\n.minuteCellContent {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1px;\n}\n\n.minuteCellStack {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 0;\n    line-height: 1.05;\n}\n\n.minuteCellTime {\n    color: #8a96a3;\n    font-size: 9px;\n    font-weight: 600;\n}\n\n.minuteCellValue {\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.minuteNavBtn {\n    width: 11px;\n    height: 20px;\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: #4b71a2;\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n}\n\n.minuteNavBtn:hover:not(:disabled) {\n    color: #022352;\n}\n\n.minuteNavBtn:disabled {\n    opacity: 0.25;\n    cursor: not-allowed;\n}\n\n/* =========================================\n   DEVICE ID COLUMN\n========================================= */\n\n.colDeviceId {\n    width: 9%;\n}\n\n.deviceIdCell {\n    color: #697681;\n    font-size: 11px !important;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `DeviceTransmissionTable_card__UCZLN`,
	"cardHeader": `DeviceTransmissionTable_cardHeader__dMzwf`,
	"titleBar": `DeviceTransmissionTable_titleBar__5C4w6`,
	"title": `DeviceTransmissionTable_title__dCn7u`,
	"subtitle": `DeviceTransmissionTable_subtitle__j8VRO`,
	"tableWrapper": `DeviceTransmissionTable_tableWrapper__QG5Ns`,
	"mainTable": `DeviceTransmissionTable_mainTable__sd6Kc`,
	"colCity": `DeviceTransmissionTable_colCity__MQACt`,
	"colStatus": `DeviceTransmissionTable_colStatus__-2m4w`,
	"colDelayPct": `DeviceTransmissionTable_colDelayPct__0IBJd`,
	"colNarrow": `DeviceTransmissionTable_colNarrow__VYwWX`,
	"colBucket": `DeviceTransmissionTable_colBucket__djPnk`,
	"hourHeader": `DeviceTransmissionTable_hourHeader__dEjMF`,
	"hourHeaderContent": `DeviceTransmissionTable_hourHeaderContent__dmKbn`,
	"hourLabel": `DeviceTransmissionTable_hourLabel__R9RB5`,
	"hourNavButton": `DeviceTransmissionTable_hourNavButton__xN3sE`,
	"hourHeaderAnimation": `DeviceTransmissionTable_hourHeaderAnimation__29beu`,
	"hourlyColumnFade": `DeviceTransmissionTable_hourlyColumnFade__YFF-Y`,
	"hourCellAnimation": `DeviceTransmissionTable_hourCellAnimation__9gsBt`,
	"hourColumnAnimation": `DeviceTransmissionTable_hourColumnAnimation__CIt+U`,
	"dataRow": `DeviceTransmissionTable_dataRow__Sh4QL`,
	"cityRow": `DeviceTransmissionTable_cityRow__Fr2Np`,
	"cityRowActive": `DeviceTransmissionTable_cityRowActive__2--NU`,
	"cityCell": `DeviceTransmissionTable_cityCell__f2Ais`,
	"cityContent": `DeviceTransmissionTable_cityContent__HzT+9`,
	"accordionIcon": `DeviceTransmissionTable_accordionIcon__5HgDB`,
	"cityName": `DeviceTransmissionTable_cityName__ozt9V`,
	"depotRow": `DeviceTransmissionTable_depotRow__xWyC8`,
	"depotSlideIn": `DeviceTransmissionTable_depotSlideIn__qDdGX`,
	"depotCell": `DeviceTransmissionTable_depotCell__WC9qx`,
	"depotName": `DeviceTransmissionTable_depotName__XocdW`,
	"depotIndicator": `DeviceTransmissionTable_depotIndicator__8bC4b`,
	"statusBadge": `DeviceTransmissionTable_statusBadge__0nxoB`,
	"statusHealthy": `DeviceTransmissionTable_statusHealthy__sGh18`,
	"statusUnhealthy": `DeviceTransmissionTable_statusUnhealthy__W-MaU`,
	"delayPct": `DeviceTransmissionTable_delayPct__HbhgM`,
	"bucketCell": `DeviceTransmissionTable_bucketCell__IoP4c`,
	"downloadBtn": `DeviceTransmissionTable_downloadBtn__jPyJe`,
	"tone_green": `DeviceTransmissionTable_tone_green__p3hgS`,
	"tone_orange": `DeviceTransmissionTable_tone_orange__rK7Om`,
	"tone_yellow": `DeviceTransmissionTable_tone_yellow__w83TS`,
	"tone_red": `DeviceTransmissionTable_tone_red__Ol9Iu`,
	"tone_grey": `DeviceTransmissionTable_tone_grey__5OXGC`,
	"loadingState": `DeviceTransmissionTable_loadingState__F1gej`,
	"spinner": `DeviceTransmissionTable_spinner__93Oag`,
	"spin": `DeviceTransmissionTable_spin__sqUuy`,
	"minuteClickable": `DeviceTransmissionTable_minuteClickable__Tjxpv`,
	"minutePopover": `DeviceTransmissionTable_minutePopover__2gSSp`,
	"minutePopoverIn": `DeviceTransmissionTable_minutePopoverIn__jgwTf`,
	"minutePopoverHeader": `DeviceTransmissionTable_minutePopoverHeader__ghyGC`,
	"minutePopoverTitle": `DeviceTransmissionTable_minutePopoverTitle__Mc+KP`,
	"minutePopoverTitleBar": `DeviceTransmissionTable_minutePopoverTitleBar__iC3PJ`,
	"minutePopoverHour": `DeviceTransmissionTable_minutePopoverHour__Cc5iJ`,
	"minutePopoverClose": `DeviceTransmissionTable_minutePopoverClose__YPQZx`,
	"minutePopoverTableWrapper": `DeviceTransmissionTable_minutePopoverTableWrapper__m8bUU`,
	"minuteTable": `DeviceTransmissionTable_minuteTable__1TBEq`,
	"minuteHeader": `DeviceTransmissionTable_minuteHeader__rn6tB`,
	"minuteHeaderContent": `DeviceTransmissionTable_minuteHeaderContent__LIAwU`,
	"paginationBar": `DeviceTransmissionTable_paginationBar__Yduoz`,
	"paginationInfo": `DeviceTransmissionTable_paginationInfo__5lfKF`,
	"paginationControls": `DeviceTransmissionTable_paginationControls__jkkCK`,
	"pageSizeLabel": `DeviceTransmissionTable_pageSizeLabel__5Qk-4`,
	"pageSizeSelect": `DeviceTransmissionTable_pageSizeSelect__UhwR4`,
	"pageBtn": `DeviceTransmissionTable_pageBtn__797Xa`,
	"pageBtnActive": `DeviceTransmissionTable_pageBtnActive__K8v6v`,
	"pageEllipsis": `DeviceTransmissionTable_pageEllipsis__8TJ-W`,
	"colDepot": `DeviceTransmissionTable_colDepot__mhoLW`,
	"colVin": `DeviceTransmissionTable_colVin__FxiNb`,
	"vinRow": `DeviceTransmissionTable_vinRow__Rh38I`,
	"depotText": `DeviceTransmissionTable_depotText__JSKvw`,
	"vinCell": `DeviceTransmissionTable_vinCell__spFwi`,
	"vinRowActive": `DeviceTransmissionTable_vinRowActive__x9a9m`,
	"hourCellSelected": `DeviceTransmissionTable_hourCellSelected__HJFk9`,
	"minuteRow": `DeviceTransmissionTable_minuteRow__USvzk`,
	"minuteRowLabelCell": `DeviceTransmissionTable_minuteRowLabelCell__LaiGe`,
	"minuteRowLabel": `DeviceTransmissionTable_minuteRowLabel__ZEbrO`,
	"minuteRowRange": `DeviceTransmissionTable_minuteRowRange__bleMS`,
	"minuteCloseBtn": `DeviceTransmissionTable_minuteCloseBtn__EeFUp`,
	"minuteValueCell": `DeviceTransmissionTable_minuteValueCell__uUmDY`,
	"minuteCellContent": `DeviceTransmissionTable_minuteCellContent__mFhZH`,
	"minuteCellStack": `DeviceTransmissionTable_minuteCellStack__rqW9c`,
	"minuteCellTime": `DeviceTransmissionTable_minuteCellTime__uq4O7`,
	"minuteCellValue": `DeviceTransmissionTable_minuteCellValue__xYCc2`,
	"minuteNavBtn": `DeviceTransmissionTable_minuteNavBtn__zU3W6`,
	"colDeviceId": `DeviceTransmissionTable_colDeviceId__iitgU`,
	"deviceIdCell": `DeviceTransmissionTable_deviceIdCell__Y-n8S`
};
export default ___CSS_LOADER_EXPORT___;
